export const GlobeMark = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
    <circle cx="24" cy="24" r="17" stroke="currentColor" strokeWidth="1.6" />
    <ellipse cx="24" cy="24" rx="7.5" ry="17" stroke="currentColor" strokeWidth="1.2" opacity="0.7" />
    <path d="M7 24h34M10 15h28M10 33h28" stroke="currentColor" strokeWidth="1" opacity="0.45" />
    <ellipse cx="24" cy="24" rx="22" ry="8" transform="rotate(-24 24 24)" stroke="#10B981" strokeWidth="1.4" />
    <circle cx="44" cy="15" r="2.4" fill="#10B981" />
    <circle cx="4.5" cy="33" r="1.8" fill="#EAB308" />
  </svg>
);

export const Logo = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-2.5 text-slate-50 ${className}`} data-testid="brand-logo">
    <GlobeMark className="w-8 h-8" />
    <span className="font-display text-lg font-bold tracking-[0.18em]">AYDORIQ</span>
  </span>
);
